import { CardBody } from "reactstrap";
import ProfitWrapper from "./ProfitWrapper";
import RightSideIcon from "./RightSideIcon";

const VisitorCardBody = () => {
  return (
    <CardBody>
      <ProfitWrapper />
      <RightSideIcon />
    </CardBody>
  );
};

export default VisitorCardBody;
